<div class="centerText">
  <div class="header">
    <app-nav></app-nav>
  </div>
</div>
<router-outlet></router-outlet>
